/**
 * ProjectGuard — content-area loading boundary for project-scoped pages.
 * Renders children if project is available or loading (pages handle their own loading).
 * Only blocks with a message when loading is done and no project is selected.
 */

import type { ReactNode } from 'react';
import { useProject } from '../../contexts/ProjectContext';

export function ProjectGuard({ children }: { children: ReactNode }) {
  const { project, isLoading } = useProject();

  // While loading, render children — pages handle their own loading states.
  // Once loaded, block only if no project is selected.
  if (!isLoading && !project) {
    return (
      <div className="flex items-center justify-center h-full text-sm text-neutral-500">
        Select a project to get started
      </div>
    );
  }

  return <>{children}</>;
}
